import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFilter1"><Path d="M3 3V8.41421L9 14.4142V22.2808L15 20.7808V14.4142L21 8.41421V3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter1;
